<template>
    <QNavigation v-bind="navigationConfig" @click="onNavClick" v-if="isSupportFullscreen" :scrollTarget="scrollTarget" @change="onNavChange"> </QNavigation>
</template>
<script lang="ts" setup>
import { ref, computed, onMounted, nextTick, provide, watch } from 'vue';
import { QNavigation } from '@q-front-npm/h5-ui';
import { getNavHeight, setWebviewConfig, closeWebview, jsbSupportMap, jsbStorage, openShareTab, fusionReport } from '@q-front-npm/jsbridge';
import { useStoreCommon } from '@common/store/common';
import { useStore } from '@/store';
import { assign } from 'radash';
const storeCommon = useStoreCommon();
const store = useStore();
const isSupportFullscreen = jsbSupportMap.app.fullScreenThree && storeCommon.urlParams.full_screen === '3';

const props = withDefaults(
    defineProps<{
        config?: Record<string, any>;
        isCloseWebiew?: boolean;
        scrollTarget?: HTMLElement;
    }>(),
    {
        config: () => ({}),
        isCloseWebiew: true,
    }
);

const defaultConfig = {
    statusHeight: '36',
    fullScreen: true,
    maxWidth: `${Math.round(storeCommon.appMaxWidth)}`,
    navPadding: 0,
    title: '番外许愿节',
    menuConfig: {
        left: isSupportFullscreen
            ? [
                {
                    icon: '&#xe660;',
                    type: 'back',
                    title: '',
                    data: {},
                }
            ]
            : [],
        right: [{
            icon: '&#xe65f;',
            type: 'share',
        }],
    },
    styleConfig: {
        default: {
            title: {
                opacity: 1,
                color: '#fff',
            },
            text: {
                color: '#fff',
                opacity: 1,
            },
            bg: {
                background: 'transparent',
            },
            statusBar: 'black',
        },
        fixed: {
            text: {
                color: '#111',
                opacity: 1,
            },
            bg: {
                background: '#fff',
            },
            statusBar: 'black',
        },
    },
};
const navigationConfig = ref<Record<string, any>>(assign(defaultConfig, props.config));

const onUpdate = (config: Record<string, any>) => {
    navigationConfig.value = assign(navigationConfig.value, config);
};
const getStatusBarInfo = async() => {
    if (import.meta.env.VITE_ENV === 'dev') {
        onUpdate({
            statusHeight: '20',
        });
        storeCommon.headerHeight = 72;
        emit('initFinish');
        return;
    }
    // 侧边栏特殊处理 - 状态栏高度不一致
    const statusBarHKey = storeCommon.inSidePanel ? 'statusBarHInSidePanel' : 'statusBarH';
    let statusBarH = await jsbStorage.get(statusBarHKey, 'activityCommon');
    if (!statusBarH) {
        const navConfig = await getNavHeight();
        statusBarH = navConfig.statusBarH;
        jsbStorage.set(statusBarHKey, statusBarH, 'activityCommon');
    }
    onUpdate({
        statusHeight: statusBarH,
    });
    storeCommon.headerHeight = +statusBarH + 52;
    setWebviewConfig({ status_bar: navigationConfig.value.styleConfig.default.statusBar, });
    emit('initFinish');
};
const emit = defineEmits(['navClick', 'initFinish']);

const onNavClick = (e: Record<string, any>) => {
    emit('navClick', e);
    if (props.isCloseWebiew && e.type === 'back') {
        closeWebview();
    }
};

const onNavChange = async(data: Record<string, any>) => {
    if (data.type === 'animation') {
        setWebviewConfig({ status_bar: navigationConfig.value.styleConfig[data.value].statusBar, });
    }
};

if (storeCommon.systemInfo.inQmApp) {
    getStatusBarInfo();
}

defineExpose({
    onUpdate,
});

onMounted(() => {});
</script>

<style lang="scss" scoped>
:deep(.q-navigation-nav .btn.icon .iconfont-icon) {
    font-size: 44px;
}
</style>
